// Landing-page social hub footer — links to the official @rcd2engine channels.
import { Facebook, Instagram, Twitter, Youtube } from 'lucide-react';

const SOCIALS = [
  { icon: Facebook, label: 'Facebook', href: 'https://www.facebook.com/rcd2engine', testid: 'social-facebook' },
  { icon: Instagram, label: 'Instagram', href: 'https://www.instagram.com/rcd2engine', testid: 'social-instagram' },
  { icon: Twitter, label: 'X', href: 'https://x.com/rcd2engine', testid: 'social-x' },
  { icon: Youtube, label: 'YouTube', href: 'https://www.youtube.com/@rcd2engine', testid: 'social-youtube' },
];

export function LandingFooter(): JSX.Element {
  return (
    <footer data-testid="landing-footer" className="w-full border-t border-zinc-800/80 bg-[#070910] px-6 lg:px-16 py-8">
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-5">
        <div className="text-[11px] text-zinc-600 text-center sm:text-left">
          © {new Date().getFullYear()} RCD² Engine · The Intelligence Behind BIM
        </div>
        <div className="flex items-center gap-3">
          <span className="text-[10px] uppercase tracking-[0.2em] text-zinc-600 mr-1">Follow</span>
          {SOCIALS.map((s) => (
            <a
              key={s.label}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={s.label}
              data-testid={s.testid}
              className="h-9 w-9 grid place-items-center rounded-full border border-zinc-800 text-zinc-400 hover:text-amber-300 hover:border-amber-300/50 hover:bg-amber-300/10 transition"
            >
              <s.icon className="h-4 w-4" strokeWidth={1.75} />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}
